
export const getIntegrations = (GLOBAL_SELECTOR_CONTENT, userData) => {
    const integrations = [
        {
            title: GLOBAL_SELECTOR_CONTENT.adobe.title,
            item: userData?.defaultAdobeIO?.integration_name,
            type: 'adobe-io-integrations',
            add_new_path: "/setup/new-integration",
            label_for_new_record: GLOBAL_SELECTOR_CONTENT.adobe.no_integration_found
        },
        {
            title: GLOBAL_SELECTOR_CONTENT.github.title,
            item: userData?.defaultGithub?.name,
            type: 'github-integrations',
            add_new_path: "/setup/add-github-integration",
            label_for_new_record: GLOBAL_SELECTOR_CONTENT.github.no_integration_found
        },
        {
            title: GLOBAL_SELECTOR_CONTENT.tealium.title,
            item: userData?.defaultTealiumKey?.tealium_api_name,
            type: 'tealium-api-keys',
            add_new_path: "/setup/tealium-new-integration",
            label_for_new_record: GLOBAL_SELECTOR_CONTENT.tealium.no_integration_found
        },
        {
            title: GLOBAL_SELECTOR_CONTENT.contentful.title,
            item: userData?.defaultContentful?.name,
            type: 'contentful-integrations',
            add_new_path: "/setup/add-contentful-integration",
            label_for_new_record: GLOBAL_SELECTOR_CONTENT.contentful.no_integration_found
        },
        // {
        //     title: GLOBAL_SELECTOR_CONTENT.workspace.title,
        //     item: userData?.defaultWorkspace?.workspace_name,
        //     type: 'workspaces',
        //     add_new_path: "/setup/workspaces",
        //     label_for_new_record: GLOBAL_SELECTOR_CONTENT.workspace.no_integration_found
        // },
        {
            title: GLOBAL_SELECTOR_CONTENT.aem_adobe_io.title,
            item: userData?.defaultAEMAdobeIO?.aem_adobe_io_name,
            type: 'aem-adobe-io',
            add_new_path: "/setup/aem-adobe-io",
            label_for_new_record: GLOBAL_SELECTOR_CONTENT.aem_adobe_io.no_integration_found,
            folder: userData?.defaultAEMFolder ? userData.defaultAEMFolder : null,
        },
    ];

    // Conditionally add 'workspace' only if Adobe IO integrations exist
    if (Array.isArray(userData?.adobeIoIntegrations) && userData.adobeIoIntegrations.length > 0) {
        integrations.push({
            title: GLOBAL_SELECTOR_CONTENT.workspace.title,
            item: userData?.defaultWorkspace?.workspace_name,
            type: 'workspaces',
            add_new_path: "/setup/workspaces",
            label_for_new_record: GLOBAL_SELECTOR_CONTENT.workspace.no_integration_found
        });
    }
    return integrations
}